var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"purchase_point"}},[_c('DoronPurchaseForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }